module.exports = __webpack_public_path__ + "static/iep-logo-white-0d264513efcbf18039938989ea1ca78e.svg";